import { StyledFlex } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCyberSecurityBasicsContainer = styled.div`
  margin-bottom: 3rem;
  margin-top: 2.6rem;
`;

export const StyledFundamentalSkillsContainer = styled.div`
  margin-top: 8rem;
  margin-bottom: 3rem;
`;

export const StyledCyberSecurityCareerSkillsContainer = styled.div`
  margin-top: 10rem;
  margin-bottom: 13rem;
`;

export const StyledArrowAnchor = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
`;

export const StyledFreeRoadmapEnd = styled.div`
  margin-top: 7rem;
`;

export const StyledFreeRoadmapWrapper = styled(StyledFlex)`
  flex-direction: column;
`;

export const StyledFreeRoadmapSelectedPathWrapper = styled(StyledFlex)`
  flex-wrap: nowrap;
  align-items: unset;
`;

export const StyledFreeRoadmapSecurityAnalyst = styled(StyledFlex)`
  flex-direction: column;
  position: relative;
`;

export const StyledFreeRoadmapSelectedPath = styled(StyledFlex)`
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
`;

export const StyledLink = styled.a``;
